import AppStoreIcon from './AppStore';
import ArrowBottomIcon from './ArrowBottom';
import ArrowLeftIcon from './ArrowLeft';
import ArrowRightIcon from './ArrowRight';
import ArrowTopIcon from './ArrowTop';
import CheckmarkCircleIcon from './CheckmarkCircle';
import ChevronBottomIcon from './ChevronBottom';
import ChevronLeftIcon from './ChevronLeft';
import ChevronRightIcon from './ChevronRight';
import ChevronTopIcon from './ChevronTop';
import CloseIcon from './Close';
import DangerIcon from './Danger';
import DownloadIcon from './Download';
import EmailIcon from './Email';
import ExternalIcon from './External';
import FacebookIcon from './Facebook';
import FilterIcon from './Filter';
import GlobeIcon from './Globe';
import GooglePlayIcon from './GooglePlay';
import InstagramIcon from './Instagram';
import LinkIcon from './Link';
import LinkedinIcon from './LinkedIn';
import LockIcon from './Lock';
import LoginIcon from './Login';
import MenuIcon from './Menu';
import MinusIcon from './Minus';
import MuteIcon from './Mute';
import PauseIcon from './Pause';
import PlayIcon from './Play';
import PlusIcon from './Plus';
import QuoteIcon from './Quote';
import SearchIcon from './Search';
import SoundsOnIcon from './SoundsOn';
import XIcon from './X';
import YoutubeIcon from './Youtube';

// Factory of supported icons.

const icons = {
  link: LinkIcon,
  lock: LockIcon,
  menu: MenuIcon,
  mute: MuteIcon,
  play: PlayIcon,
  plus: PlusIcon,
  pause: PauseIcon,
  close: CloseIcon,
  email: EmailIcon,
  globe: GlobeIcon,
  login: LoginIcon,
  minus: MinusIcon,
  quote: QuoteIcon,
  danger: DangerIcon,
  filter: FilterIcon,
  search: SearchIcon,
  download: DownloadIcon,
  soundsOn: SoundsOnIcon,
  external: ExternalIcon,
  arrowTop: ArrowTopIcon,
  arrowRight: ArrowRightIcon,
  arrowBottom: ArrowBottomIcon,
  arrowLeft: ArrowLeftIcon,
  chevronTop: ChevronTopIcon,
  chevronRight: ChevronRightIcon,
  chevronBottom: ChevronBottomIcon,
  chevronLeft: ChevronLeftIcon,
  checkmarkCircle: CheckmarkCircleIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  youtube: YoutubeIcon,
  x: XIcon,
  googlePlay: GooglePlayIcon,
  appStore: AppStoreIcon,
};

/**
 * Icon types that can be used with the Icon component.
 */

export type IconType = keyof typeof icons;

/**
 * Type definition for the Icon components properties.
 */

export type IconProps = {
  className?: string;
  fill?: string;
  'aria-hidden'?: boolean | 'true' | 'false';
  'aria-label'?: string;
};

// Type definition for the IconFactory component properties.

type Props = IconProps & {
  type: IconType;
};

/**
 * Icon component that dynamically renders an SVG icon based on the type prop.
 *
 * This component allows for the inclusion of various icons without rendering them
 * as client components. Instead, the icons are imported as server components and used
 * within this component to maintain server-side rendering.
 */

export const IconFactory = ({ type, ...props }: Props) => {
  const IconComponent = icons[type];

  if (!IconComponent) return null;

  return <IconComponent {...props} />;
};

export default IconFactory;
